document.addEventListener('DOMContentLoaded', function () {
  var forms = document.querySelectorAll('.quick-add-form');
  var countElements = document.querySelectorAll('[data-cart-count]');

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        countElements.forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('button');
      var original = button.textContent;

      button.disabled = true;
      button.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to add item');
          return response.json();
        })
        .then(function () {
          button.textContent = 'ADDED TO CART';
          updateCartCount();
          setTimeout(function () {
            button.disabled = false;
            button.textContent = original;
          }, 1800);
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = 'TRY AGAIN';
          setTimeout(function () {
            button.textContent = original;
          }, 1800);
        });
    });
  });

  var fill = document.querySelector('[data-shipping-fill]');
  var message = document.querySelector('[data-shipping-message]');
  if (fill && message) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var target = 7500;
        var total = cart.total_price || 0;
        fill.style.width = Math.min((total / target) * 100, 100) + '%';
        message.textContent = total >= target
          ? 'Mission complete — you unlocked free shipping!'
          : 'Add ' + ((target - total) / 100).toLocaleString('en-US', {style:'currency',currency:'USD'}) + ' more to unlock free shipping.';
      });
  }
});
